import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_INFO as IconInfo } from '@bwoty-web/ui-kit/icons';

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  > div {
    align-items: flex-start;
    display: flex;
    position: relative;
    text-align: left;
    width: 100%;
    color: var(--color-text);
    font: var(--font-body-m);
  }

  /* Mobile only */
  @media (max-width: 767px) {
    display: ${(props) => (props.isMobile ? 'block' : 'none')};
    margin: var(--space-200) 0 var(--space-500);
  }
  /* Dektop only */
  @media (min-width: 768px) {
    display: ${(props) => (props.isMobile ? 'none' : 'block')};
    flex: 1;
    margin-left: var(--space-500);
    padding-left: var(--space-400);
    border-left: 1px solid var(--color-grey-200);
    &:nth-child(2) {
      margin-left: 0;
      padding-left: 0;
      padding-right: var(--space-1000);
      border-left: 0;
    }
  }
`;

const ExtraIcon = styled(Icon)`
  min-width: 2.2rem;
  margin-right: var(--space-400);
  fill: var(--color-wave);
`;

const ExtraInfo = ({ message, mobile }) => {
  return (
    <Wrapper isMobile={mobile}>
      <div>
        <ExtraIcon size="s" path={IconInfo} />
        {message}
      </div>
    </Wrapper>
  );
};

ExtraInfo.propTypes = {
  message: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
};

ExtraInfo.defaultProps = {
  mobile: false,
};

export default ExtraInfo;
